export const settingsConstants = {
  APP_SETTINGS_CHECK_VERSION_REQUEST: 'APP_SETTINGS_CHECK_VERSION_REQUEST',
  APP_SETTINGS_CHECK_VERSION_SUCCESS: 'APP_SETTINGS_CHECK_VERSION_SUCCESS',
  APP_SETTINGS_CHECK_VERSION_FAILURE: 'APP_SETTINGS_CHECK_VERSION_FAILURE',

  APP_SETTINGS_SET_LOCALE_SUCCESS: 'APP_SETTINGS_SET_LOCALE_SUCCESS'
};
